import request from '@/utils/request'

// 统计列表(主数据列表)
export function loadStoreVisitCheckInStatisticsListDataApi(data) {
  return request({
    url: 'web/storeVisitCheckIn/listDataByStatistics',
    method: 'post',
    data
  })
}
// 统计导出
export function loadStoreVisitCheckInStatisticsExportDataApi(data) {
  return request({
    url: 'web/storeVisitCheckIn/exportDataByStatistics',
    method: 'post',
    data
  })
}
// 查询待报告钉钉签到数
export function findTaskReportCheckCountByUserIdApi(data) {
  return request({
    url: 'web/storeVisitCheckIn/findTaskReportCheckCountByUserId',
    method: 'post',
    data
  })
}
// 查询钉钉签到照片信息
export function findCheckInImgByCheckIdApi(data) {
  return request({
    url: 'web/storeVisitCheckIn/findCheckInImgByCheckId',
    method: 'post',
    data
  })
}
// 获取签到终端GPS数据
export function findCheckInStoreByTMapApi(data) {
  return request({
    url: 'web/storeVisitCheckIn/findCheckInStoreByTMap',
    method: 'post',
    data
  })
}
